// A headline number with its label and a sparkline. Hovering the sparkline
// swaps the sub line for the hovered point. Text wears text tokens only.
import React from 'react';
import { GEyebrow } from './atoms';
import { Sparkline, type SparkPoint } from './Sparkline';
import { fmtTime } from '../fmt';

export function StatTile({ label, value, sub, points, format, tone = 'normal' }: {
  label: string;
  value: string;
  sub?: string;
  points?: Array<[number, number]>;
  format?: (v: number) => string;
  /** `alert` only when the number itself is a problem (errors > 0), never for emphasis */
  tone?: 'normal' | 'alert';
}) {
  const [hover, setHover] = React.useState<SparkPoint | null>(null);
  const fmt = format ?? ((v: number) => String(v));
  return (
    <div style={{ background: 'var(--bg-panel)', borderRadius: 'var(--r-card)', padding: '16px 18px 14px', minWidth: 0 }}>
      <GEyebrow style={{ fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</GEyebrow>
      <div className="display-num" style={{ fontSize: 30, marginTop: 6, color: tone === 'alert' ? 'var(--s-err-fg)' : 'var(--fg)' }}>{value}</div>
      <div style={{ fontFamily: 'var(--ff-code)', fontSize: 11.5, color: 'var(--fg-4)', marginTop: 4, minHeight: 15, whiteSpace: 'nowrap' }}>
        {hover ? `${fmt(hover.v)} at ${fmtTime(hover.t)}` : (sub ?? '')}
      </div>
      {points && <div style={{ marginTop: 8 }}><Sparkline points={points} onHover={setHover} title={label} /></div>}
    </div>
  );
}
